import './LegalPage.css';

/**
 * Cookies Page
 */
export const Cookies = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-page__content">
          <h1 className="legal-page__title">Politique de Cookies</h1>
          
          <section className="legal-page__section">
            <h2>Utilisation actuelle des cookies</h2>
            <p>
              <strong>Bookiner n'utilise actuellement aucun cookie.</strong>
            </p>
            <p>
              Notre site est une page de présentation simple qui ne nécessite pas l'utilisation de cookies pour fonctionner.
              Aucune donnée n'est stockée sur votre navigateur lors de votre visite.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Qu'est-ce qu'un cookie ?</h2>
            <p>
              Un cookie est un petit fichier texte stocké sur votre appareil lors de la visite d'un site web.
              Les cookies permettent au site de mémoriser vos préférences et d'améliorer votre expérience de navigation.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Utilisation future possible</h2>
            <p>
              À l'avenir, nous pourrions être amenés à utiliser des cookies pour :
            </p>
            <ul>
              <li>Analyser l'utilisation du site et améliorer nos services</li>
              <li>Mémoriser vos préférences de navigation</li>
              <li>Assurer la sécurité et le bon fonctionnement de la plateforme</li>
            </ul>
            <p>
              Si nous décidons d'utiliser des cookies, vous en serez informé et aurez la possibilité de gérer vos préférences.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Contact</h2>
            <p>
              Pour toute question concernant notre politique de cookies ou l'utilisation de vos données,
              contactez-nous à : contact@bookiner.co
            </p>
          </section>

          <a href="/" className="legal-page__back">← Retour à l'accueil</a>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
